import React from 'react';

import SrBox from 'client/components/SrBox';
import SrLink from 'client/components/SrLink/SrLink';
import SrText from 'client/components/SrText';

const SrPartnerBillingSectionHeaderAction = ({ name, to, onClick }) => {
  const SrLinkOrDiv = to ? SrLink : SrBox;

  return (
    <SrBox key={name} marginLeft="8px" {...(onClick && { onClick })}>
      <SrLinkOrDiv {...(to && { to })}>
        <SrText font="greycliff" weight="600" fontSize="16px" color="blue300" cursor="pointer">
          {name}
        </SrText>
      </SrLinkOrDiv>
    </SrBox>
  );
};

export default SrPartnerBillingSectionHeaderAction;
